import React, { useState } from 'react';
import { FaBars, FaTimes, FaGithub, FaLinkedin } from 'react-icons/fa'
import { HiOutlineMail } from 'react-icons/hi'
import { BsFillPersonLinesFill } from 'react-icons/bs'
import { Link } from 'react-scroll'

const Navbar = () => {

    // Hamburger Menu button
    const [nav, setNav] = useState(false)

    const handleClick = () => {
        setNav(!nav)
    }


    return (
        // Navbar

        // CSS attribute - [custom styling value]
        <div className='fixed w-full h-[100px] flex justify-between items-center px-5 mx-3 bg-[#0a192f] text-gray-300 z-10'>
            {/* Logo */}
            <div className='animate__animated animate__rubberBand animate__repeat-2'>
                <a href='/' className='text-4xl' style={{ fontFamily: 'Dancing Script' }}>Alistair Saldanha</a>
            </div>
            {/* Menu */}
            <ul className='hidden md:flex animate__animated animate__bounceIn'> {/* md-medium responsive */}
                <li className='hover:text-pink-600 duration-300'><Link to="home" smooth={true} duration={500} >Home</Link></li>
                <li className='hover:text-pink-600 duration-300'><Link to="about" smooth={true} duration={500} >About</Link></li>
                <li className='hover:text-pink-600 duration-300'><Link to="skills" smooth={true} duration={500} >Skills</Link></li>
                <li className='hover:text-pink-600 duration-300'><Link to="projects" smooth={true} duration={500} >Projects</Link></li>
                <li className='hover:text-pink-600 duration-300'><Link to="contact" smooth={true} duration={500} >Contact</Link></li>
            </ul>
            {/* Hamburger */}
            <div onClick={handleClick} className='md:hidden z-10 mx-3'>
                {!nav ? <FaBars /> : <FaTimes />}
            </div>

            {/* Mobile Menu */}
            <ul className={!nav ? 'hidden' : 'absolute top-0 left-0 w-full h-screen bg-[#0a192f] flex flex-col justify-center items-center'}>
                <li className='py-5 text-4xl'><Link onClick={handleClick} to="home" smooth={true} duration={500} >Home</Link></li>
                <li className='py-5 text-4xl'><Link onClick={handleClick} to="about" smooth={true} duration={500} >About</Link></li>
                <li className='py-5 text-4xl'><Link onClick={handleClick} to="skills" smooth={true} duration={500} >Skills</Link></li>
                <li className='py-5 text-4xl'><Link onClick={handleClick} to="projects" smooth={true} duration={500} >Projects</Link></li>
                <li className='py-5 text-4xl'><Link onClick={handleClick} to="contact" smooth={true} duration={500} >Contact</Link></li>
            </ul>

            {/* Social Icons */}
            <div className='hidden lg:flex fixed flex-col top-[35%] left-0'>
                <ul>
                    {/* For the transition effect margin is given negative */}
                    <li className='w-[160px] h-[50px] flex justify-between items-center ml-[-100px] hover:ml-[0px] duration-500 bg-blue-800'>
                        <a className='flex justify-between items-center w-full text-gray-300' href="https://www.linkedin.com/in/alistair-saldanha/" target="_blank" rel="noreferrer">LinkedIn <FaLinkedin size={30} /></a>
                    </li>
                    <li className='w-[160px] h-[50px] flex justify-between items-center ml-[-100px] hover:ml-[0px] duration-500 bg-[#333333]'>
                        <a className='flex justify-between items-center w-full text-gray-300' href="https://github.com/STARBOY05" target="_blank" rel="noreferrer">Github <FaGithub size={30} /></a>
                    </li>
                    <li className='w-[160px] h-[50px] flex justify-between items-center ml-[-100px] hover:ml-[0px] duration-500 bg-[#046a93]'>
                        <a className='flex justify-between items-center w-full text-gray-300' href="https://mail.google.com/mail/u/0/#inbox?compose=DmwnWsTRSZgnGDGjKRslZtlntMjvswQjcrvzskzPnWghKzSVcrSPCxhjtZqVGPwsprPxKVKTxQwQ" target="_blank" rel="noreferrer">Email <HiOutlineMail size={30} /></a>
                    </li>
                    <li className='w-[160px] h-[50px] flex justify-between items-center ml-[-100px] hover:ml-[0px] duration-500 bg-[#4f688c]'>
                        <a className='flex justify-between items-center w-full text-gray-300' href="https://docs.google.com/document/d/1a8B8mNzqLoW_oMj6PTga6nhlZu5eGQ2kQz0X7wq55ao/edit?usp=sharing" target="_blank" rel="noreferrer">Resume <BsFillPersonLinesFill size={30} /></a>
                    </li>
                </ul>
            </div>
        </div>
    )
}

export default Navbar